export default "/images/exhibition-banner2.png?0af382b38897cdb4e9f8048019ab5b1c";